import $ from 'jquery';
export default class MenuWidget {
    static $element = $('.js__toggle-vertical-menu');
    static $collapseWrapper = $('.js__toggle-vertical-menu-wrapper');
    static isAnimating = false;
    static init() {
        this.$element.on('click', e => this.slideToggle(e));
    }
    static slideToggle(e) {
        const $menuWrapper = this.$collapseWrapper ?? this.$element;
        if (!this.isAnimating) {
            this.isAnimating = true;
            $menuWrapper.find('.js__toggle-content').slideToggle(() => {
                $menuWrapper.toggleClass('expanded', !$menuWrapper.first().hasClass('expanded'));
                this.isAnimating = false;
            });
        }
    }
}
